import axios from "./AxiosService";

export function downloadMedicalConsentService() {
  return axios
    .get("medicalconsent", {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json"
      },
      responseType: "blob"
    })
    .then(response => {
      return response;
    });
}

export function submitMedicalConsent(medicalConsent) {
  return axios
    .post("medicalconsent", medicalConsent, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      return error;
    });
}
